import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const BottomNavbar = ({ sidebaritems }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [activeMenuIndex, setActiveMenuIndex] = useState(null);

  useEffect(() => {
    const foundIndex = sidebaritems.findIndex((nav) =>
      location.pathname.startsWith(nav.path)
    );
    setActiveMenuIndex(foundIndex !== -1 ? foundIndex : null);
  }, [location.pathname, sidebaritems]);

  const handleMenuClick = (index, nav) => {
    setActiveMenuIndex(index);
    const targetPath = nav.subNav?.length
      ? nav.path + nav.subNav[0].path
      : nav.path;
    navigate(targetPath);
  };

  return (
    <>
      {sidebaritems.map((item, index) => {
        const isActive = index === activeMenuIndex;

        return (
          <button
            key={index}
            onClick={() => handleMenuClick(index, item)}
            className={`flex-center cursor-pointer w-fit gap-1 text-[#0A2341] py-2 md:py-4 px-2 md:px-3 ${
              isActive ? "bg-primary-10  rounded-lg" : ""
            }`}
            aria-expanded={isActive}
          >
            <img
              src={item.icon}
              alt={`${item.title} icon`}
              className="w-[30px] h-[30px] "
            />
            {isActive && (
              <p className="text-[10px] font-[500] md:text-[14px]">
                {item.title}
              </p>
            )}
          </button>
        );
      })}
    </>
  );
};

export default BottomNavbar;
